<template>
  <div class="edit-police pt-0">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="edit-police__head">
          <div class="edit-police__head__title">
            <span>Persistencia de clientes</span>
          </div>
        </div>
        <div class="text-center text-main" v-if="flags.searching">
          <i class="fas fa-circle-notch fa-spin d-block mb-1"></i>
          Cargando datos...
        </div>
        <div class="edit-police__body" v-if="!flags.searching">
          <div class="row">
            <div class="col-md-6">
              <div class="card mb-3" v-if="data">
                <div class="card-header">
                  <b>PERSISTENCIA DE CLIENTES</b>
                </div>
                <div class="card-body">
                  <div class="row" v-for="(item, index) in data.monthlyAverage" v-bind:key="index">
                    <div class="col-md-7">Mes {{ index + 1 }}: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ item }}%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  
  
<script lang="ts">
import { BButton, BModal, VBModal, BCardText } from "bootstrap-vue";
import Datepicker from "vuejs-datepicker";
import Vuelidate from "vuelidate";
import es from "vuejs-datepicker/dist/locale/translations/es";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";
import {
  required,
  minLength,
  maxLength,
  email,
  numeric,
  sameAs,
  requiredIf,
} from "vuelidate/lib/validators";
import axios from "axios";
import valid from "card-validator";
import moment from "moment";
import { init } from "echarts/lib/echarts";
import { environment } from "../../../environment/environment";
import { defineComponent } from "vue";
import useVuelidate from "@vuelidate/core";
import policyService from "../../../services/policy-service";

export default defineComponent({
  components: {
    Datepicker,
    BCardText,
    VueSlider,
    BModal,
  },
  data() {
    return {
      apiUrl: environment.api,
      data: null,
      collection: null,
      v$: useVuelidate(),
      years: [2020, 2021, 2022, 2023],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      pendingPayments: 0,
      flags: {
        searching: false,
      },
    };
  },
  created() {
    this.init();
  },
  watch: {},
  methods: {
    async init() {
      this.flags.searching = true;

      await this.getPersistence();

      this.flags.searching = false;
    },
    async getPersistence() {
      let result = await policyService.getPersistence();

      if (result.data) {
        this.data = result.data;
      }
    },
    formatNumber(number) {
      var number = number.toLocaleString("en-US");
      if (number.split(".").length === 2) {
        return number.split(".")[0];
      }
      return number;
    },
  },
});
</script>
  
<style lang="scss">
/**/
@import "../../../styles/abstracts/variables";
/**/

.edit-police {
  background-color: #f4f6fc;

  &__head {
    margin: 0px 0px 40px 0px;

    &__title {
      font-weight: 500;
      font-size: 28px;
      color: #0855c4;
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;

      button {
        padding: 8px 25px 8px 25px;
        font-weight: 500;
        border-radius: 5px;
        border: none;
        font-size: 14px;
        margin-right: 130px;
        color: white;
        width: 250px !important;
        background-color: $primaryRed;
        transition: 0.3s;

        &:hover {
          box-shadow: 0px 8px 20px rgba($color: $primaryRed, $alpha: 0.5);
        }
      }
    }
  }

  &__body {
    .row {
      .form-group {
        .form-control {
          height: 57px;
          font-size: 14px;
          border: 1px solid #c5c5c5;
          border-radius: 4px;
          border-width: 2px;

          &:focus {
            box-shadow: 0px 1px 8px rgba($color: #000000, $alpha: 0.1);
          }
        }

        button {
          padding: 8px 25px 8px 25px;
          font-weight: 500;
          border-radius: 5px;
          border: none;
          font-size: 14px;
          color: white;
          background-color: $primaryBlue;
        }
      }
    }

    &__box {
      .title {
        color: #0855c4;
        font-size: 14px;
        margin: 0px 0px 5px 0px;
      }

      &__space {
        display: block;
        margin: 40px 0px 20px 0px;
        opacity: 0.2;
        width: 100%;
        height: 1px;
        background-color: $secondGray;
      }

      &__input-email {
        .form-control {
          height: 57px !important;
          font-size: 14px;
          border: 1px solid #c5c5c5;
          border-radius: 4px;
          border-width: 2px;
        }
      }

      h4 {
        font-weight: 500;
        font-size: 18px;
        color: $primaryBlue !important;
        display: flex;
        margin-bottom: 20px;
        width: 100%;
        align-items: center;
        justify-content: space-between;
      }

      .row {
        .col-3 {
          span {
            display: block;
            color: $primaryGray;
            display: block;
            font-size: 14px;
          }

          span:not(.police-state) {
            margin-top: 8px;
          }
        }

        .col-10 {
          .form-group {
            margin: 0px 0px 20px 0px;

            &:first-child {
              margin: 15px 0px 20px 0px;
            }

            label {
              color: $primaryBlue;
              font-size: 14px;
              margin: 0px 0px 5px 0px;
            }

            &:last-child {
              display: flex;
              justify-content: end;
            }
          }
        }

        .col-4 {
          display: flex;
          justify-content: end;

          button {
            padding: 8px 25px 8px 25px;
            font-weight: 500;
            border-radius: 5px;
            border: none;
            font-size: 14px;
            color: white;
            background-color: $primaryBlue;
          }
        }
      }

      .table {
        thead {
          tr {
            th {
              vertical-align: top;
              text-transform: uppercase;
              font-size: 12px;
              letter-spacing: 0.5px;
              color: $primaryGray;
              padding: 0.72rem 2rem;
              border-bottom: 2px solid #ebe9f1;
              background-color: #f3f2f7;
            }
          }
        }

        tbody {
          tr {
            background-color: white;

            td {
              font-size: 14px;
              color: $primaryGray;
              border: none;
              padding: 0.72rem 2rem;
              vertical-align: middle;
              border-top: 1px solid #ebe9f1;

              .badge {
                // display: flex;
                // justify-content: center;
                // align-items: center;
                line-height: 17px;
                font-size: 11px;
                height: 25px;
                width: fit-content;
                margin-right: 8px;
              }

              a {
                text-decoration: none;
                color: $primaryBlue !important;
              }

              .delete {
                display: flex;
                align-items: center;
                color: $primaryRed;
                background-color: transparent;
                border: none;

                span {
                  display: block;
                  padding-left: 10px;
                }
              }

              .badge-success {
                background-color: $green;
              }

              .badge-info {
                background-color: $info;
              }

              .badge-danger {
                background-color: $primaryRed;
              }

              .badge-warning {
                background-color: $warning;
              }
            }
          }

          tr:nth-child(even) {
            background-color: transparent;
          }
        }
      }

      .table > :not(caption) > * > * {
        box-shadow: none;
      }
    }
  }
}

// .edit-police {
//   .modal-blue {
//     .modal-dialog {
//       .modal-content {
//         background-color: #fff;

//         .modal-footer,
//         .modal-header {
//           display: block;
//         }
//       }
//     }

//     &__head {
//       color: #0855c4;
//       text-align: center;
//       font-weight: 500;

//       h3 {
//         font-weight: bolder;
//         color: $thirdColor;
//       }

//       i {
//         margin-bottom: 10px;
//         color: $thirdColor;
//       }

//       p {
//         a {
//           color: #fff;
//           text-decoration: underline;
//         }
//       }
//     }

//     &__body {
//       p {
//         font-size: 14px;
//         color: #fff;
//       }
//     }
//   }

// }

.moda-blue {
  .modal {
    .modal-dialog {
      .modal-content {
        .modal-body {
          padding-left: 0px;
          padding-right: 0px;
          background-color: #fff;
          padding-top: 0px;
          border-radius: 20px;
        }
      }
    }
  }
}

.invalid {
  input {
    border-color: $danger !important;
  }
}

@media (min-width: 576px) {
  .modal-sm {
  }
}
</style>
  